<template>
    <!-- 银行卡开户方式选择 -->
    <div class="wk-input wk-input-box dropDown-capital-box posi-relative">
        <span class="input-left-label">{{label}}</span>
        <!--下拉框的 显示框-->
        <div class="dropDown-title-box posi-relative dropDown-capital" 
            :class="{readonly:readonly===''}" @click="titleCliCk">
            <!-- 未选择 提示请选择开户方式 -->
            <p v-if='!capitalInfo.capitalName' class="dropDown-title-placeholder dropDown-capital">请选择开户方式</p>
            <!-- 已选中的开户方式 -->
            <p v-else class="posi-absolute dropDown-title dropDown-capital">{{capitalInfo.capitalName}}</p>
             <!-- 在 readonly 下 启用 -->
            <p v-if="readonly===''" class="disabled posi-absolute"></p>
            <!-- 尾部 三角号 icon -->
            <p class="posi-absolute dropDown-title-sanjiao dropDown-capital">
                <img src="../../assets/img/dropdow-icon.png" class="dropDown-title-sanjiao dropDown-capital">
            </p>
        </div>     
        <!--下拉框的选项-->
        <ul v-if="isShowBox" class="dropDown-item-list posi-absolute flex dropDown-capital" :style="styleCpt">
            <li v-if="!dataList.length || dataList.length==0" class="dropDown-item not-data txt-gray"> 
               请选先择银行
            </li>
            <li v-else v-for="(item,k) in dataList" @click="itemClick(k)" :key='k' 
                :class="{active:k===capitalIndex}" class="dropDown-item"> 
                <p> {{item.capitalName}} </p>
                <p class="txt-gray-g-g"> 仅需验证预留手机号 </p>
                <p class="txt-gray-g-g"> {{item.limitDesc}} </p>
                <p class="txt-gray-g-g">{{item.remitFlag == 1 ? '该卡支持汇款转账！':'该卡暂不支持汇款转账！'}}</p>
            </li>
        </ul>
    </div>			
</template>

<script>
    export default {
        props: ['label','value','dataList','styleCpt','readonly'],
        mounted(){
            this.initHandler(this);
        },
        data(){
            return{
                capitalInfo:'',
                capitalIndex:'',
                isShowBox:false
            }
        },
        watch:{
            dataList(){
                this.capitalInfo = ''
            },
            value(){
                // 一般是回显会用到
                if(this.capitalInfo === ''){
                    this.showSltBankCapital(this);
                }
            }
        },
        beforeDestroy() {
            window.removeEventListener('click', this.windowHanlderOfBankCapital);
        },
        methods:{
            // title 单击事件
            titleCliCk(){
                this.isShowBox = !this.isShowBox;
            },
            // 银行选择事件
            itemClick(k){
                this.capitalIndex = k;
                this.capitalInfo = this.dataList[k];
                this.isShowBox = false;
                this.$emit('input',this.capitalInfo);
            },
            // window 点击事件
            windowHanlderOfBankCapital(e){
                let target = e.target;
                // 如果点击的 不是 title 和 item 都隐藏
                if( target.className.indexOf('dropDown-capital') < 0 ){
                    this.isShowBox = false;
                }
            },
            // 页面初始化数据
            initHandler(that){
                // 如果已有默认选中的开户方式
                if(that.value){
                    // 遍历匹配出 默认显示的开户方式
                    that.showSltBankCapital(that);
                }
                // 绑定 window 事件
                window.addEventListener('click', this.windowHanlderOfBankCapital);
            },
            // 显示已选中的 银行资金方式
            showSltBankCapital(that){
                 that.dataList.map((val,k)=>{
                    if( val.capitalType == that.value.capitalType && 
                        val.capitalMode == that.value.capitalMode){
                        that.capitalIndex = k;
                        that.capitalInfo = val;
                    }
                })   
            }
        }
    }
</script>

<style scoped lang="less">
    .dropDown-capital-box{
        margin:.9rem 0;
        // 下拉框的 title
        .dropDown-title-box{
            width: 17.3rem;
            height: 2.1rem;
            padding:0 .8rem;
            line-height: 2rem;
            border: 1px solid #d1d1d1;
            cursor:pointer; 
            // 未选择时提示
            .dropDown-title-placeholder{
                color:#cacaca;
                font-size: .8rem;
            }
            // 已选择的银行 名称
            .dropDown-title{
                top:0;
                left:.9rem;
                font-size: .8rem;
            }
            // 已选择的银行 icon
            .dropDown-title-icon{
                max-width:1.2rem;
                margin-top:.4rem;  
            }
            // readonly 下启用
            p.disabled{
                top:0;
                right:0;
                width:18.4rem;
                height:2rem;
                background:rgba(245, 247, 250, .1);
                z-index: 3;
            }
            // 三角号的icon
            p:last-child{
                top:0;
                right:0;
                bottom:0;
                width:2rem;
                background: #F8F8F8;
                border-left:.05rem solid #D6D6D6;
                text-align: center;
            }
        }
        // 下拉选择项
        .dropDown-item-list{
            top:2.5rem;
            right:-5.3rem;
            width: 23.8rem;
            min-height:1.5rem;
            padding:.2rem .6rem .5rem ;
            flex-wrap: wrap;
            background: #FAFAFA;
            border:.05rem solid #D1D1D1;
            box-shadow:0 2px 9px 0 rgba(205,200,200,0.48);
            z-index: 1000;
            li{
                width:11rem;
                height: 7.5rem;
                padding:.5rem;
                margin:.3rem .5rem 0 0;
                border:.05rem solid #EBEBEB;
                border-radius: .2rem;
                cursor: pointer;
                transition: all .2s linear;
                background: #fff;
                // 类型 title
                p:first-child{
                    padding:.6rem 0;
                    font-size: .8rem;
                }
                // 银行 名称
                p:last-child{
                    padding-top:.3rem;
                    line-height: 1.3rem;
                }
            }
            li:nth-child(2n){
                margin-right:0;
            }
            li:hover,li.active{
                border:.05rem solid #DD867E;
                background:#FFF0EE;
            }
            li.not-data{
                height:1rem;
                padding-top:0;
                background:none;
                border:none;
            }
        }
        // readonly 模式下的 背景颜色
        .readonly{
            background: #F5F7FA; 
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelectBankCapital.vue